<template>
  <v-container fluid>
    <v-app-bar dark app color="primary">
      <v-app-bar-nav-icon>
        <v-icon>mdi-calendar-week</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>Wochenübersicht</v-toolbar-title>

      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tabs-slider color="error"></v-tabs-slider>
          <v-tab :to="{ name: 'WeekOverviewSchoolclasses' }"> Klassen </v-tab>
          <v-tab :to="{ name: 'WeekOverviewRooms' }"> Zimmer </v-tab>
          <v-tab :to="{ name: 'WeekOverviewTeachers' }">Lehrkräfte </v-tab>
          <v-tab :to="{ name: 'WeekOverviewSchoolclassesCalendar' }">
            Kalender (Klassen)
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <router-view :search="search"></router-view>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import SearchField from "@/components/SearchField";

export default defineComponent({
  name: "WeekOverview",
  components: {
    SearchField,
  },
  data() {
    return {
      search: null,
    };
  },
});
</script>
